import {Box} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {Heart} from 'lucide-react';
import React, {FC} from 'react';

import {
  useMetroAddFavoriteProductGuarded,
  useMetroDeleteFavoriteProduct,
  useMetroFavoriteProductIds,
} from '../../api/queries';

interface Props {
  productId: number;
  size?: number;
  stopPropagation?: boolean;
  hasBackground?: boolean;
}

export const MetroFavoriteButton: FC<Props> = ({productId, size = 20, hasBackground, stopPropagation = true}) => {
  const {data: favoriteIds} = useMetroFavoriteProductIds();
  const addFavorite = useMetroAddFavoriteProductGuarded();
  const deleteFavorite = useMetroDeleteFavoriteProduct();

  const isFavorite = !!favoriteIds?.product_ids?.includes(productId);
  const isLoading = addFavorite.isLoading || deleteFavorite.isLoading;

  const onClick = (e: React.MouseEvent) => {
    if (stopPropagation) e.stopPropagation();
    if (isLoading) return;

    const payload = {product_id: productId};
    if (isFavorite) {
      deleteFavorite.mutate(payload);
    } else {
      addFavorite.mutate(payload);
    }
  };

  return (
    <Box
      cursor={isLoading ? 'progress' : 'pointer'}
      onClick={onClick}
      display="inline-flex"
      opacity={isLoading ? 0.6 : 1}
      transition="opacity 0.2s"
      backgroundColor={hasBackground ? colors.white : undefined}
      borderRadius={hasBackground ? 'full' : undefined}
      p={hasBackground ? 1 : undefined}
    >
      <Heart
        color={isFavorite ? colors.pink : colors.textGray}
        fill={isFavorite ? colors.pink : 'transparent'}
        size={size}
      />
    </Box>
  );
};
